import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./appoitmentProgramPopup.module.css";
import { IPopupWithoutProps } from "../../../types/types";
import { ITreatmentPlan } from "../../../services/types/user.types";
import { getPrintDate } from "../../../utils/utils";
import i18n from "../../../i18n";

function AppoitmentProgramPopup({ onClose, treatmentPlan }: IPopupWithoutProps & { treatmentPlan: ITreatmentPlan }) {
    const treatmentSequence = (treatmentPlan.sequenceCount === 1 ? t('ONCE_IN_A_WHILE') : treatmentPlan.sequenceCount === 2 ? t('TWICE_IN') : ` ${treatmentPlan.sequenceCount} ${t("TIMES_ON")}`) + treatmentPlan.period
    return (
        <article dir={i18n.dir()} className={popupStyles.popup}>
            <div className={popupStyles.popup__content}>
                {/* <button className={popupStyles.popup__closeBtn} onClick={onClose} /> */}
                <h2 className={popupStyles.popup__title}>{t('PROGRAM')} {treatmentPlan.appointmentsProgram.name}</h2>
                <p className={popupStyles.popup__text}>
                    {t('DATE_OF_PROGRAM_ESTABLISHMENT')} {getPrintDate(new Date(treatmentPlan.appointmentsProgram.createDate))}
                </p>
                <p className={popupStyles.popup__text}>
                    {t('NAME_OF_CAREGIVER')} {treatmentPlan.therapistUserName ?? t('NO_INFORMATION')}
                </p>
                <p className={popupStyles.popup__text}>
                    {t('NUMBER_OF_MEETINGS')} {treatmentPlan.appointmentsProgram.countOfAppointments}
                </p>
                <p className={popupStyles.popup__text}>
                    {t('FREQUENCY')} {(!treatmentPlan.period || !treatmentPlan.sequenceCount ) ? t('NO_INFORMATION') : treatmentSequence } 
                </p>
                <p className={popupStyles.popup__text}>
                    {t('TREATMENT_METHOD')} {treatmentPlan.mediaName ?? t('NO_INFORMATION')}
                </p>
                <button
                    className={`button hover ${popupStyles.popup__nextBtn}`}
                    onClick={onClose}
                >
                    {t('APPROVAL_AND_CLOSURE')}</button>
            </div>
        </article>
    );
}

export default AppoitmentProgramPopup;
